import { ButtonHTMLAttributes, useRef } from 'react';

import { Button } from './button';
import { cn } from '@web/lib/shadcn';
import { toast } from 'sonner';

export function Attach({
  children,
  className,
  disabled,
  setAttachment,
}: ButtonHTMLAttributes<HTMLButtonElement> & {
  setAttachment: (file: File[]) => void;
}) {
  const hiddenFileInput = useRef<HTMLInputElement>(null);

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    // if any files are selected
    if (e.target.files) {
      const files = Array.from(e.target.files);
      const MAX_FILE_SIZE = 5 * 1024 * 1024; // 5MB in bytes

      // Check if any file exceeds the size limit
      const oversizedFiles = files.filter((file) => file.size > MAX_FILE_SIZE);

      if (oversizedFiles.length > 0) {
        toast.error('Files must be less than 5MB each');
        return;
      }
      setAttachment(files);
    }
  };

  return (
    <Button
      variant="ghost"
      size="icon"
      aria-label="Attach file"
      onClick={() => {
        // clear previously selected files, if any
        if (hiddenFileInput.current) hiddenFileInput.current.value = '';

        // open file selection dialog
        hiddenFileInput.current?.click();
      }}
      className={cn('', className)}
      disabled={disabled}
    >
      {children}

      <input
        type="file"
        multiple
        className="hidden"
        ref={hiddenFileInput}
        onChange={handleFileChange}
      />
    </Button>
  );
}
